import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Text, HStack } from '@chakra-ui/react';

interface ModalRetornoProps {
  isOpen: boolean;
  onClose: () => void;
  mensagem: string;
  tipo: 'sucesso' | 'erro';
  dica?: string; 
}

const ModalRetorno: React.FC<ModalRetornoProps> = ({ isOpen, onClose, mensagem, tipo, dica }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent textAlign="center" py={4} borderRadius="lg">
        <ModalHeader>
          <Text fontSize="xl" fontWeight="bold" color={tipo === 'erro' ? 'red.500' : 'green.500'}>
            {tipo === 'erro' ? 'Erro' : 'Sucesso'}
          </Text>
        </ModalHeader>
        <ModalBody>
          <Text fontSize="lg" fontWeight="medium">
            {mensagem}
          </Text>

          {dica && (
            <HStack justify={'center'}>
              <Text fontSize="xs" color="blue.600" fontWeight={'extrabold'} >
                💡 Dica: 
              </Text >
              <Text fontSize="xs" color="blue.600" mt={4}>
                {dica}
              </Text>
            </HStack>
          )}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme={tipo === 'erro' ? 'red' : 'green'} onClick={onClose} w="full">
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalRetorno;